import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); // Subtle shadow backdrop
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalCard = styled.div`
  background: ${({ theme }) => theme.colors.default[0]};
  padding: 48px 40px;
  border-radius: 12px;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 90%;
  box-shadow: 4px 4px 25px rgba(0, 0, 0, 0.25);
  text-align: center;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.default.default};
  font-size: 27px;
  font-weight: 700;
  line-height: 1.2;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.default.default};
  font-size: 16px;
  line-height: 1.5;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`;
